export const COPY = Object.freeze({
  SUBMIT: 'Queue for Approval',
  EXIT_PROMPT: 'Are you sure you want to leave this page while we are submitting your payment request?',
  HEADER: 'Manual Payout',
  SUBHEADER: 'Payout Overview',
  BACK_BUTTON: 'Back to User Profile',
  SUCCESS_TOAST: 'Payout queued for approval.',
});
